import { FormControl, Grid, Typography, useMediaQuery } from "@mui/material";
import { useField, useFormikContext } from "formik";
import StyleAsarInputComponent, {
  desktopStyleLabel,
  mobileStyleLabel,
  phoneStyleLabel,
  phoneStyleLabelWithError,
  styleLabel,
  styleLabelWithError,
} from "./StyleAsaInputCompnent";
import { Link } from "react-router-dom";

export default function AsarFormikInput({
  label,
  name,
  placeholder = undefined,
  type = "text",
  maxLength = undefined,
  width = undefined,
  startAdornment = undefined,
  endAdornment = undefined,
  multiline = undefined,
  showResetPassword = false,
  inputProps = {},
  ...otherProps
}) {
  const [field, meta, helpers] = useField(name);
  const { setFieldValue } = useFormikContext();
  const md = useMediaQuery("(max-width:450px)");

  const handleNumberChange = (e) => {
    const onlyNumbers = e.target.value.replace(/\D/g, "");
    helpers.setValue(onlyNumbers);
  };

  const handleNumberKeyPress = (e) => {
    if (!/[0-9]|Backspace|Delete|ArrowLeft|ArrowRight|Tab/.test(e.key)) {
      e.preventDefault();
    }
  };

  return (
    <FormControl
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "5px",
        width: width ?? "100%",
      }}
      variant="standard"
      error={meta.error !== undefined}
    >
      {label && (
        <>
          <Grid
            display={"flex"}
            flexDirection={"row"}
            justifyContent={"space-between"}
            width={"100%"}
          >
            <Typography
              color="text.primary"
              sx={
                meta.error
                  ? md
                    ? phoneStyleLabelWithError
                    : styleLabelWithError
                  : md
                    ? phoneStyleLabel
                    : styleLabel
              }
            >
              {label}
            </Typography>
            {type === "password" && showResetPassword && (
              <Link to="/forgetPassword">
                <Typography
                  sx={
                    md
                      ? {
                          // color: "var(--emr-primary)",
                          color: "var(--emr-text-light)",
                          cursor: "pointer",
                          ...mobileStyleLabel,
                        }
                      : {
                          // color: "var(--emr-primary)",
                          color: "var(--emr-text-light)",
                          cursor: "pointer",
                          ...desktopStyleLabel,
                        }
                  }
                >
                  فراموشی رمز عبور
                </Typography>
              </Link>
            )}
          </Grid>
        </>
      )}
      <StyleAsarInputComponent
        multiline={multiline}
        inputProps={{
          maxLength: maxLength,
          ...inputProps,
        }}
        type={type}
        onKeyPress={(e) =>
          type === "number" ? handleNumberKeyPress(e) : undefined
        }
        onChange={(e) => {
          if (type === "number") {
            handleNumberChange(e);
            return;
          }
          setFieldValue(
            field.name,
            type === "number" || otherProps.inputMode === "numeric"
              ? e.target.value.replace(/\D/g, "")
              : e.target.value,
          );
        }}
        style={startAdornment ? { paddingRight: "10px" } : {}}
        placeholder={placeholder}
        value={field.value}
        startAdornment={startAdornment}
        endAdornment={endAdornment}
        {...otherProps}
      />
      {meta.error && (
        <Typography variant="caption" color="error" sx={{ ml: "4px" }}>
          {meta.error}
        </Typography>
      )}
    </FormControl>
  );
}
